import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Home from './Layouts/Main/Home';
import TokenPage from './Layouts/Main/TokenPage';
import CompanyAccordion from './Components/Company/CompanyAccordion';
import Header from './Layouts/Header/Header';
import HeaderLogin from './Layouts/Header/HeaderLogin';
import HeaderAfterLogin from './Layouts/Header/HeaderAfterLogin';
import Footer from './Layouts/Footer/Footer';
import ProjectDetails from './Components/Allprojects/ProjectDetails';
import JoinUs from './Components/Account/JoinUs';
import Cookies from 'universal-cookie';
import ResetPassword from './Components/Account/ResetPassword';
import ChangePassword from './Components/Account/ChangePassword';
import UserProfileMainComponent from './Components/UserProfile/UserProfileMainComponent';
import ServiceRequest from './Components/ServiceRequest/ServiceRequest';
import ViewServiceRequest from './Components/ServiceRequest/ViewServiceRequest';
import EditCompany from './Components/Company/EditCompany';
import ActivityLog from './Components/Activity/ActivityLog';
import LoginPage from './Components/_Authentication/LoginPage';
import SetResetPassword from './Components/Account/SetResetPassword';
import XcorpJoinUs from './Components/Account/XcorpJoinUs';

function App() {
  const cookies = new Cookies();
  
  // Custom close button component - improved visibility
  const CloseButton = ({ closeToast }) => (
    <button
      onClick={closeToast}
      style={{
        background: 'rgba(0,0,0,0.1)',
        border: '1px solid rgba(0,0,0,0.2)',
        color: '#333',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        padding: '2px',
        width: '22px',
        height: '22px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '3px',
        opacity: 0.8,
        transition: 'all 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.target.style.background = 'rgba(0,0,0,0.2)';
        e.target.style.opacity = '1';
      }}
      onMouseLeave={(e) => {
        e.target.style.background = 'rgba(0,0,0,0.1)';
        e.target.style.opacity = '0.8';
      }}
    >
      ×
    </button>
  );
  // Log to console when Footer renders (for local debugging)
  useEffect(() => {
          console.log("Footer rendered from local environment");
        }, []);
  
  return (
    <div className="app-container">
      <BrowserRouter>
        {/* Header always at the top, does not shrink */}
        <div className="header-container">
          {cookies.get("accessToken") == null ? <HeaderLogin /> : <Header />}
        </div>
        {/* Main content grows */}
        <main className="main-content landing-main-content">
          <Routes>
            <Route path="/" element={<Home />} /> 
            <Route path="/home" element={<TokenPage />} />
  
            <Route path="/projects" element={<CompanyAccordion />} />
            <Route path="/joinUs" element={<JoinUs />} />
            <Route path="/xcorpjoinus" element={<XcorpJoinUs />} />
            <Route path="/projects/:companyId/:projectId" element={<ProjectDetails />} />
            <Route path="/projects/:projectId" element={<ProjectDetails />} />
            <Route path="/resetPassword" element={<ResetPassword />} />
            <Route path="/changePassword" element={<ChangePassword />} />
             <Route path="/changepassword-reset" element={<SetResetPassword />} />
            <Route path="/developer/*" element={<HeaderAfterLogin />} />
            <Route path="/userProfile" element={<UserProfileMainComponent />} />
            <Route path="/serviceRequest" element={<ServiceRequest />} />
            <Route path="/serviceRequest/:company/:confirmedRepId/:requestType/:requestSubType" element={<ServiceRequest />} />
            <Route path="/serviceRequest/:company/:confirmedRepId/:requestType/:requestSubType/:usrExist" element={<ServiceRequest />} />
            <Route path="/viewserviceRequests" element={<ViewServiceRequest />} />
            <Route path="/activityLog" element={<ActivityLog />} />
            <Route path="/editCompany/:companyId" element={<EditCompany />} />
            <Route path="/loginPage" element={<LoginPage />} />
          </Routes>
        </main>
        {/* Footer always at the bottom, does not shrink */}
        <Footer />
        {/* Single global ToastContainer for the entire app */}
        <ToastContainer 
          position="bottom-right"
          autoClose={8000}
          hideProgressBar={false}
          closeOnClick={true}
          pauseOnHover={true}
          draggable={true}
          transition={Slide}
          closeButton={CloseButton}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;